import type { AppEndpointBuilder } from 'store/types';

import { toExperimentModel, toFeaturesModel, toMaintenanceWindowModel } from './helpers';
import type { ExperimentModel, FeaturesModel, MaintenanceWindowModel } from './models';

export const commonEndpoints = (builder: AppEndpointBuilder) => ({
  // #region Queries
  getExperiments: builder.query<ExperimentModel[], void>({
    query: () => ({
      url: 'experiments',
      method: 'GET',
    }),
    providesTags: (result) =>
      result
        ? [...result.map(({ id }) => ({ type: 'Experiments' as const, id })), { type: 'Experiments', id: 'LIST' }]
        : [{ type: 'Experiments', id: 'LIST' }],
    transformResponse: toExperimentModel,
  }),

  getFeatures: builder.query<FeaturesModel, void>({
    query: () => ({
      url: 'features',
      method: 'GET',
    }),
    providesTags: ['Features'],
    transformResponse: toFeaturesModel,
  }),

  getMaintenanceWindows: builder.query<MaintenanceWindowModel[], void>({
    query: () => ({
      url: 'maintenance-windows',
      method: 'GET',
    }),
    providesTags: (result) =>
      result
        ? [
            ...result.map(({ id }) => ({ type: 'Maintenance-Window' as const, id })),
            { type: 'Maintenance-Window', id: 'LIST' },
          ]
        : [{ type: 'Maintenance-Window', id: 'LIST' }],
    transformResponse: toMaintenanceWindowModel,
  }),
  // #endregion Queries
});
